import { render, staticRenderFns } from "./ArrowBase.vue?vue&type=template&id=2c9ab567&scoped=true&"
import script from "./ArrowBase.vue?vue&type=script&lang=js&"
export * from "./ArrowBase.vue?vue&type=script&lang=js&"
import style0 from "./ArrowBase.vue?vue&type=style&index=0&id=2c9ab567&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ab567",
  null
  
)

export default component.exports